webpackJsonp([133186989568310],{

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SecondPage = function SecondPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'Instruction' },
	      _react2.default.createElement(
	        'div',
	        { className: 'InstructionGroup' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Step 2: Acquire data for training'
	        ),
	        _react2.default.createElement(
	          'progress',
	          { value: '40', max: '100' },
	          '40 %'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '* In this step, you will need to choose one from the below datasets for training an AI-based hiring model. Each row in the datasets represents a candidate, with the following features: gender (M: male, F: female), score (Y: good performance in interview, N: poor performance in interview), hired (1: hired, 0: not hired). Did you notice any differences between the two datasets? (Hint: the differences are in Line 23-24)'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: 'https://docs.google.com/spreadsheets/d/1e8vgvBZ4OpnOXi4BeuYXPi8wBw5qBGXSEMIO1iNUgDQ/edit?usp=sharing', title: 'Dataset1', target: '_blank' },
	            'Dataset1'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://docs.google.com/spreadsheets/d/1RMZQzXNUdPZi6oOFiMGp-qonQjleNd7GVvuQzIcPcYQ/edit?usp=sharing', title: 'Dataset2', target: '_blank' },
	            'Dataset2'
	          )
	        ),
	        _react2.default.createElement('p', null),
	        _react2.default.createElement(
	          'p',
	          null,
	          '* Which dataset will you use? Please remember your choice.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '* Now let\'s learn basics of the model we\'ll be using: random forest.'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/1-bias/' },
	          'Back'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/3-rf/' },
	          'Next step'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          'Go back to the homepage'
	        )
	      )
	    )
	  );
	};
	
	exports.default = SecondPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-2-acquire-js-466f0d9081272afb31d6.js